export default __webpack_public_path__ + "static/media/link.154ca7f9.svg";